import {IconButton} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useConfirmDialog from "../../hooks/useConfirmDialog.tsx";

interface BackButtonProps {
    isFormDirty: boolean;
    navigateBackTo: string;
}

export const BackButton = (props: BackButtonProps) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const {confirm, dialog} = useConfirmDialog();

    const handleBackClicked = async () => {
        if (props.isFormDirty) {
            const ok = await confirm({
                message: t("defaults.confirmLeave"),
                confirmLabel: t("defaults.leaveConfirm"),
                cancelLabel: t("defaults.leaveStay"),
                danger: true,
            });
            if (!ok) return;
        }
        void navigate(props.navigateBackTo);
    };

    return (
        <>
            <IconButton
                aria-label={t("defaults.goBack")}
                className="h-fit text-an-ink"
                onClick={() => { void handleBackClicked(); }}
            >
                <ArrowBackIcon/>
            </IconButton>
            {dialog}
        </>
    );
};
